import React from 'react'
import { Box, SxProps, Theme, Typography } from '@mui/material'

interface RewardTipProps {
  title?: string
  sx?: SxProps<Theme>
  type?: 'restaurant' | 'eater'
}

const RewardTip: React.FC<RewardTipProps> = ({ title, sx, type = 'eater' }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      border={1}
      borderColor="grey.200"
      bgcolor={type === 'eater' ? 'grey.100' : 'warning.100'}
      py={1}
      px="10px"
      borderRadius={type === 'eater' ? '8px' : '50px'}
      sx={sx}
    >
      <Box component="img" src="/images/leaderboard/coin-yellow.png" />
      <Typography variant="subtitle1">{title}</Typography>
    </Box>
  )
}

export default RewardTip
